import useCurrentUserStore from "@/store";
import { Navigate, Outlet } from "react-router-dom";

export const AuthLayout = () => {
  const { dashboardAccessToken } = useCurrentUserStore();
  if (dashboardAccessToken) {
    return <Navigate to={"/app-creation"} />;
  }
  return <Outlet />;
};
